// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import { JsonValueSchema } from '../inputTypeSchemas/JsonValueSchema'
import { TargetTypeSchema } from '../inputTypeSchemas/TargetTypeSchema'
import { SignalCategorySchema } from '../inputTypeSchemas/SignalCategorySchema'
import { SignalOriginSchema } from '../inputTypeSchemas/SignalOriginSchema'
import { SignalRankSchema } from '../inputTypeSchemas/SignalRankSchema'
import { SignalStageSchema } from '../inputTypeSchemas/SignalStageSchema'
import { SignalStatusSchema } from '../inputTypeSchemas/SignalStatusSchema'
import { BlockedReasonSchema } from '../inputTypeSchemas/BlockedReasonSchema'
import { SignalAssetTypeSchema } from '../inputTypeSchemas/SignalAssetTypeSchema'

/////////////////////////////////////////
// SIGNAL SCHEMA
/////////////////////////////////////////

export const SignalSchema = z.object({
  targetType: TargetTypeSchema,
  category: SignalCategorySchema,
  origin: SignalOriginSchema,
  rank: SignalRankSchema,
  stage: SignalStageSchema,
  status: SignalStatusSchema.nullable(),
  blockedReason: BlockedReasonSchema.nullable(),
  assetType: SignalAssetTypeSchema.nullable(),
  id: z.string(),
  tenantId: z.string().nullable(),
  targetId: z.string(),
  endpointId: z.string().nullable(),
  harEntryId: z.string().nullable(),
  entryPointId: z.string().nullable(),
  securityTestCaseId: z.string().nullable(),
  securityTestCaseSummary: z.string().nullable(),
  description: z.string().nullable(),
  analysis: z.string().nullable(),
  confidence: z.number().int().nullable(),
  reason: z.string().nullable(),
  cweIds: z.string().array(),
  owaspCategory: z.string().nullable(),
  isAuthenticated: z.boolean().nullable(),
  smokeTestSummary: z.string().nullable(),
  lastSmokeTestedAt: z.coerce.date().nullable(),
  assigneeId: z.string().nullable(),
  isActive: z.boolean(),
  prUrl: z.string().nullable(),
  validatedByCode: z.boolean().nullable(),
  validationRejected: z.boolean().nullable(),
  validationReasoning: z.string().nullable(),
  isAppWide: z.boolean().nullable(),
  metadata: JsonValueSchema.nullable(),
  sourceLabel: z.string().nullable(),
  sourceProvider: z.string().nullable(),
  importBatchId: z.string().nullable(),
  assetId: z.string().nullable(),
  dedupeFingerprint: z.string().nullable(),
  latestExecutionStatus: z.string().nullable(),
  latestExecutionAt: z.coerce.date().nullable(),
  linkedFindingSeverity: z.string().nullable(),
  sortSnapshotSyncedAt: z.coerce.date().nullable(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  sensitive: z.boolean(),
})

export type Signal = z.infer<typeof SignalSchema>

export default SignalSchema;
